import { render, staticRenderFns } from "./IntegrationMembers.vue?vue&type=template&id=21c17c3a"
import script from "./IntegrationMembers.vue?vue&type=script&lang=js"
export * from "./IntegrationMembers.vue?vue&type=script&lang=js"
import style0 from "./IntegrationMembers.vue?vue&type=style&index=0&id=21c17c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports